/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./MessagesSidebar.vue?vue&type=template&id=4dcc7f1d&scoped=true"
import script from "./MessagesSidebar.vue?vue&type=script&lang=js"
export * from "./MessagesSidebar.vue?vue&type=script&lang=js"
import style0 from "./MessagesSidebar.vue?vue&type=style&index=0&id=4dcc7f1d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcc7f1d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dcc7f1d')) {
      api.createRecord('4dcc7f1d', component.options)
    } else {
      api.reload('4dcc7f1d', component.options)
    }
    module.hot.accept("./MessagesSidebar.vue?vue&type=template&id=4dcc7f1d&scoped=true", function () {
      api.rerender('4dcc7f1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/messages/MessagesSidebar.vue"
export default component.exports